"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SamplingEventStatus = void 0;
var SamplingEventStatus;
(function (SamplingEventStatus) {
    SamplingEventStatus[SamplingEventStatus["New"] = 0] = "New";
    SamplingEventStatus[SamplingEventStatus["SampleDesignCompleted"] = 1] = "SampleDesignCompleted";
    SamplingEventStatus[SamplingEventStatus["SampleDesignReviewed"] = 2] = "SampleDesignReviewed";
    SamplingEventStatus[SamplingEventStatus["SampleCollectionCompleted"] = 3] = "SampleCollectionCompleted";
    SamplingEventStatus[SamplingEventStatus["ResultsInReview"] = 4] = "ResultsInReview";
    SamplingEventStatus[SamplingEventStatus["ResultsReleased"] = 5] = "ResultsReleased";
    SamplingEventStatus[SamplingEventStatus["Completed"] = 10] = "Completed";
})(SamplingEventStatus = exports.SamplingEventStatus || (exports.SamplingEventStatus = {}));
//# sourceMappingURL=SamplingEventStatus.js.map